export enum BenchmarkType {
  NATIONAL = 'national',
  SUB_REGION = 'sub_region',
  COHORT = 'cohort',
  SIZE_GROUP = 'size_group',
}
